import type { ReactElement } from "react";

import type { Meta, StoryObj } from "@storybook/react";

import { Text } from "@/ui/core";
import { HStack, VStack } from "@/ui/layout";
import ArrowBulletSVG from "@/ui/theme/icons/illustrations/ArrowBulletSVG";
import CheckSVG from "@/ui/theme/icons/illustrations/CheckSVG";
import VideoSVG from "@/ui/theme/icons/illustrations/VideoSVG";

enum PreviewSize {
  Large = 60,
  Medium = 40,
  Small = 20,
}

interface IllustrationEntry {
  Component: (props: Partial<SizeDimensions>) => ReactElement;
  name: string;
}

const Illustrations: IllustrationEntry[] = [
  { Component: ArrowBulletSVG, name: "Arrow Bullet" },
  { Component: CheckSVG, name: "Check" },
  { Component: VideoSVG, name: "Video" },
];

interface StandaloneIllustrationsProps {
  size: PreviewSize;
}

const Gallery = ({ size }: StandaloneIllustrationsProps): ReactElement => (
  <HStack flexWrap="wrap" gap={30}>
    {Illustrations.map(({ Component, name }) => (
      <VStack alignItems="center" gap={6} key={name}>
        <Component height={size} width={size} />
        <Text testID={name} variant="caption">
          {name}
        </Text>
      </VStack>
    ))}
  </HStack>
);

const StoryMeta: Meta<StandaloneIllustrationsProps> = {
  title: "Theme/Standalone Illustrations",
  component: Gallery,
  args: {
    size: PreviewSize.Medium,
  },
  argTypes: {
    size: {
      control: "select",
      options: Object.values(PreviewSize),
    },
  },
};

type Story = StoryObj<StandaloneIllustrationsProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
